/**
* Created by MARCIANO_8
* Marciano Digital Agency
* www.marciano.com.mx
* Date: 09/04/2018.
*
* users-create-view Vue Component
*/
<template>
  <form-modal
    :hide-secondary-button="true"
    primary-button-label="Crear distribuidor"
    modal-title="Crear distribuidor"
    @closeModal="onCloseModal"
    @primaryButtonClick="onSave">
    <div class="content">
      <dealers-form ref="form"/>
    </div>
  </form-modal>
</template>

////////////////////////////////////////////
//                                  SCRIPT
////////////////////////////////////////////
<script>
import FormModal from '@/components/_shared/form-modal'
import DealersForm from '@/modules/dealers/dealers-form'
export default {
  name: 'DealersCreateView',
  components: {FormModal, DealersForm},
  methods: {
    onCloseModal () {
      this.$router.push({name: 'dealers'})
    },
    onSave () {
      this.$refs.form.onSubmit()
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
  .content{
    padding: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/app/dealers/dealers-create-view.vue